import React, { useEffect } from 'react';

interface ToastProps {
  id: string;
  message: string;
  type: 'success' | 'info';
  onDismiss: (id: string) => void;
  duration?: number;
}

const Toast: React.FC<ToastProps> = ({ id, message, type, onDismiss, duration = 4500 }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onDismiss(id);
    }, duration);

    return () => clearTimeout(timer);
  }, [id, duration, onDismiss]);

  return (
    <div className={`toast toast-${type}`}>
      <div className="toast-content">
        {type === 'success' && <span className="toast-icon">🎉</span>}
        {type === 'info' && <span className="toast-icon">💸</span>}
        <span className="toast-message">{message}</span>
      </div>
    </div>
  );
};

export default Toast;

